import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  InputNumber,
  Switch,
  Select,
  message,
} from "antd";
import get from "lodash/get";
import find from "lodash/find";
import { connect } from "react-redux";

import {
  scheduleEcoaUploadGet,
  scheduleEcoaUploadTest,
  scheduleEcoaUploadUpdate,
  scheduleEcoaUploadActivate,
  scheduleEcoaUploadDeactivate,
} from "../../api/requests";

import classes from "./ScheduleUploadEcoaForm.css";
import {
  getApiEcoaCreatePermission,
  getApiEcoaUpdatePermission,
  getApiEcoaDeletePermission,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import map from "lodash/map";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

const timezones = require("../../utils/timezones.json");

class ScheduleUpload1Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingData: true,
      isLoading: false,
      isLoadingTest: false,
      requestResult: {},
      schedule: {},
      test: {},
      shortTz: get(
        find(timezones, ({ utc }) => utc.includes(this.props.time_zone)),
        "abbr",
        ""
      ),
    };
  }

  async componentDidMount() {
    // this.getStatus();

    await this.getSchedule();

    this.setState({ isLoadingData: false });
  }

  async getSchedule() {
    try {
      const { data } = await scheduleEcoaUploadGet();
      this.setState({ schedule: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  }

  async getStatus() {
    this.setState({ isLoadingTest: true });
    try {
      const { data } = await scheduleEcoaUploadTest();
      this.setState({ test: data });
    } catch (e) {
      this.setState({ test: { error: get(e, "response.data.error") } });
    }

    this.setState({ isLoadingTest: false });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.props.apiEcoaCreatePermission) {
      return;
    }

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        const scheduled = { ...values };

        try {
          await scheduleEcoaUploadUpdate({ ...scheduled });
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
            test: {},
          });

          this.getStatus();
          this.getSchedule();

          // setTimeout(() => {
          //   this.props.onSubmit(this.props.id);
          // }, 2200);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onSwitchActivation = (state) => async () => {
    this.setState({ isLoading: true });

    try {
      if (state === "active") {
        await scheduleEcoaUploadDeactivate();
      } else {
        await scheduleEcoaUploadActivate();
      }

      message.success(this.props.i18n.t("Saved"));

      await this.getSchedule();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
    }

    this.setState({ isLoading: false });
  };

  /*onChangeTimezone = (value) => {
    const shortTz = get(find(timezones, ({ utc }) => utc.includes(value)), 'abbr', '') || [null, null];
    this.props.form.setFieldsValue({'short_tz': shortTz});
  };*/

  render() {
    const {
      isLoading,
      requestResult,
      isLoadingData,
      isLoadingTest,
      test,
      schedule,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      apiEcoaCreatePermission,
      apiEcoaUpdatePermission,
      apiEcoaDeletePermission,
    } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceScheduleUploadEcoaForm:Send data to ECOA"
            )}
            &nbsp;
            {schedule.state && (
              <Badge
                count={schedule.state}
                style={{
                  backgroundColor:
                    schedule.state === "active" ? "#52c41a" : "#777",
                }}
              />
            )}
          </h4>

          {isLoadingTest ? (
            <p>
              {this.props.i18n.t("Connection test")} &nbsp;{" "}
              <Icon type="loading" />
            </p>
          ) : test.error || test.status ? (
            <p>
              <Badge
                count={
                  test.error ||
                  `${this.props.i18n.t("Connection")} : ${test.status}`
                }
                style={{ backgroundColor: test.error ? "#f00" : "#52c41a" }}
              />
            </p>
          ) : (
            <div style={{ margin: '0 0 5px' }}>
              <Button size="small" type="primary" onClick={() => { this.getStatus(); }}>
                Test API connection
              </Button>
            </div>
          )}

          {isLoadingData ? (
            <Icon type="loading" />
          ) : (
            <div>
              <Row gutter={12}>
                <Col span={12}>
                  <label>
                    <b>URL</b>
                    <Form.Item>
                      {getFieldDecorator("url", {
                        initialValue: schedule.url,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label style={{ display: "block", width: "170px" }}>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:Minutes delay"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("minutes_time", {
                        initialValue: schedule.minutes_time,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<InputNumber />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Username")}</b>
                    <Form.Item>
                      {getFieldDecorator("username", {
                        initialValue: schedule.username,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Password")}</b>
                    <Form.Item>
                      {getFieldDecorator("password", {
                        initialValue: schedule.password,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input.Password />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:User pool id"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("user_pool_id", {
                        initialValue: schedule.user_pool_id,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:User client id"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("user_client_id", {
                        initialValue: schedule.user_client_id,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:Organization id"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("organization_id", {
                        initialValue: schedule.organization_id,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:Study name"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("study_name", {
                        initialValue: schedule.study_name,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:Default locale name"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("local_name", {
                        initialValue: schedule.local_name,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(
                        <Select placeholder={this.props.i18n.t("Select")}>
                          <Option value="deCH">{this.props.i18n.t("Switzerland German")}</Option>
                          <Option value="deDE">{this.props.i18n.t("Germany German")}</Option>
                          <Option value="enAU">{this.props.i18n.t("Australia English")}</Option>
                          <Option value="enCA">{this.props.i18n.t("Canada English")}</Option>
                          <Option value="enUS">{this.props.i18n.t("United States English")}</Option>
                          <Option value="esUS">{this.props.i18n.t("United States Spanish")}</Option>
                          <Option value="frCA">{this.props.i18n.t("Canada French")}</Option>
                          <Option value="frCH">{this.props.i18n.t("Switzerland French")}</Option>
                          <Option value="itCH">{this.props.i18n.t("Switzerland Italian")}</Option>
                          <Option value="svSE">{this.props.i18n.t("Sweden Swedish")}</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>

                {/*<Col span={12}>
                  <label style={{ display: 'block', width: '170px' }}>
                    <b>Time Zone:</b>
                    <Form.Item>
                      {getFieldDecorator('time_zone', {
                        initialValue: get(schedule, 'time_zone', '')
                      })(
                        <Select showSearch placeholder='Select' onChange={this.onChangeTimezone}>
                          <Option value="">None</Option>
                          {timezones.map(({ utc }) => utc.map((tz, i) => (
                            <Option value={tz} key={i}>{tz}</Option>
                          )))}
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>*/}
              </Row>

              {requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}

              <div className={classes.actionWrapper}>
                {apiEcoaCreatePermission && (
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      className={classes.submitButton}
                    >
                      {this.props.i18n.t("Save")}
                      {isLoading && <Icon type="loading" />}
                    </Button>
                    &nbsp; &nbsp;
                  </Form.Item>
                )}

                <Button
                  type="default"
                  size="large"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={this.props.onCancel}
                >
                  {this.props.i18n.t("Cancel")}
                </Button>

                {((apiEcoaDeletePermission && schedule.state === "active") ||
                  (apiEcoaUpdatePermission && schedule.state !== "active")) && (
                  <div className={classes.activateWrap}>
                    {this.props.i18n.t("Activate")} &nbsp;
                    <Switch
                      disabled={isLoading}
                      className={classes.activateBtn}
                      checked={schedule.state === "active"}
                      onChange={this.onSwitchActivation(schedule.state)}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  apiEcoaCreatePermission: getApiEcoaCreatePermission(state),
  apiEcoaUpdatePermission: getApiEcoaUpdatePermission(state),
  apiEcoaDeletePermission: getApiEcoaDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "scheduleUploadForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ScheduleUpload1Form))
);



// WEBPACK FOOTER //
// ./src/components/ScheduleUploadEcoaForm/ScheduleUploadEcoaForm.js